import BigNumber from "bignumber.js";
import React from "react";
import { getPercentageFromPrice, padDP } from "../../../../../utils/ciutils";
import { COLORS } from "../../../../constants";
import useTradeStore from "../../../../hooks/trade/tradeStore";
import { BidRow, OrderBookContainer, Price, Quantity, Total } from "./styles";
import { useTradePosition } from "../../../../hooks/trade/tradePosition";
import { formatKNumber } from '@utils/formatKNumber.tsx';

const BidsSection = ({ bids, max, setOrderBookValue }: any) => {
  const { data, mutate: mutateTradeStore } = useTradeStore();

  const { orderlist: list } = useTradePosition();

  const orderType = data?.main_sub || "M";

  return (
    <OrderBookContainer>
      {bids?.length &&
        bids?.map((item: any, index: number) => {
          const check = list?.find((i: any) => i?.order_price == item?.price);

          return (
            <BidRow
              key={index.toString()}
              onClick={() => {
                mutateTradeStore({
                  ...data,
                  order_price: item?.price,
                });

                setOrderBookValue(item?.price);
              }}
            >
              <Price asks={false}>{padDP(item?.price, data?.dp)}</Price>
              <Quantity>
                {check ? (
                  <span
                    style={{
                      color: COLORS.lightGreen,
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    ㆍ
                  </span>
                ) : null}
                {orderType === 'M' ? BigNumber(item?.amount || 0)
                    .plus(check?.remain_amount || 0)
                    .toFixed(5)
                  :
                  formatKNumber(
                    BigNumber(item?.amount * item?.price || 0)
                      .plus(check?.remain_amount || 0)
                      .toNumber()
                  )}
              </Quantity>
              <Total
                style={{
                  transition: "all 300ms ease",
                  minWidth: "90px",
                  backgroundSize: `${getPercentageFromPrice(
                    item?.sumAmount,
                    0,
                    max
                  )}% 100%`,
                  backgroundPosition: `${getPercentageFromPrice(
                    item?.sumAmount,
                    0,
                    max
                  )}% left`,
                  marginLeft: "10px",
                  backgroundImage: `linear-gradient(to right, #37A16A1A ${getPercentageFromPrice(
                    item?.sumAmount,
                    0,
                    max
                  )}%  0%)`,
                }}
              >
                {orderType === 'M' ? padDP(item?.sumAmount, data?.dp2 || data?.dp) : formatKNumber( BigNumber(item?.sumAmount * item?.price || 0)
                  .plus(check?.remain_amount || 0)
                  .toNumber())}
              </Total>
            </BidRow>
          );
        })}
    </OrderBookContainer>
  );
};

export default React.memo(BidsSection)
